import React, { useEffect } from "react";
import { datadogRum } from "@datadog/browser-rum";
import { DefaultEnv } from "store/env";
import { datadogLogs } from "@datadog/browser-logs";
import { useAuth0 } from "@auth0/auth0-react";
import { computeUserProps } from "./computeUserProps";

const {
  dataDogAppId,
  dataDogToken,
  isDataDogUser,
  envName,
  version
} = DefaultEnv;

if (dataDogAppId && dataDogToken && !isDataDogUser) {
  datadogRum.init({
    applicationId: dataDogAppId,
    clientToken: dataDogToken,
    sampleRate: 100,
    env: envName,
    version
  });

  datadogLogs.logger.info("Init RUM logs");
  datadogRum.addRumGlobalContext("env", { envName });
} else {
  datadogRum.init({
    applicationId: "123",
    clientToken: "123",
    datacenter: undefined,
    sampleRate: 0
  });
}

//Rum and logs are very insistent on being initialized just once.
//Putting them in the React lifecycle at all causes strange issues around init.
//Avoid that and make them both static.
export const Rum: React.FC = () => {
  const { user } = useAuth0();
  useEffect(() => {
    let userDomain;
    if (user) {
      const { domain } = computeUserProps(user);
      userDomain = domain;
    }
    datadogRum.addRumGlobalContext("user", userDomain);
  }, [user]);
  return <></>;
};
